export default __webpack_public_path__ + "static/media/logo.deb8b8b0.svg";